<template>
  <div>
    <div class="dashboard-invoice-status-summary">
      <ApexChart type="bar" :series="series" :options="chartOptions" height="110" />
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button class="btn btn-sm btn-outline-secondary" @click="goToInvoiceList">Til rapport</button>
    </div>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';
import { mapGetters } from 'vuex';

export default {
  name: 'DashboardInvoiceStatusSummary',
  components: {
    ApexChart,
  },
  computed: {
    ...mapGetters('reports', {
      data: 'getDashboardInvoiceStatusTotals',
    }),
    series() {
      return [
        {
          name: 'Betalt',
          data: [this.data.paid],
          color: 'var(--green)',
        },
        {
          name: 'Ubetalt <15 dager',
          data: [this.data.from1To15],
          color: 'var(--warning)',
        },
        {
          name: 'Ubetalt >15 dager',
          data: [this.data.from15],
          color: 'var(--red)',
        },
        {
          name: 'Ikke forfalt',
          data: [this.data.notYetDue],
          color: 'var(--gray)',
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
          stacked: true,
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          show: false,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          show: false,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  methods: {
    moneyFormatter(value, { seriesIndex, w }) {
      return this.$options.filters.toCurrency(w.config.series[seriesIndex]);
    },
    goToInvoiceList() {
      this.$router.push({
        name: 'reports_invoices',
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard-invoice-status-summary {
  .metrics {
    display: grid;
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2rem 1.25rem;
  }

  .unit-chart {
    grid-column: 1 / -1;
  }

  .money-chart {
    grid-column: 1 / -1;
  }
}
</style>
